<script lang="ts">
import { watch } from 'vue';

import type { LightboxBackgroundVideoItem, LightboxComponents, LightboxI18n } from './phxsg-lightbox.vue';

export interface BackgroundVideoMountPlayer {
  show?: () => void;
  play?: () => void;
}

export interface BackgroundVideoMountPayload {
  player: {
    value: BackgroundVideoMountPlayer | null;
  };
}

interface PhxsgLightboxBackgroundVideoItemProps {
  item: LightboxBackgroundVideoItem;
  components: LightboxComponents;
  i18n: LightboxI18n;
}
</script>

<script setup lang="ts">
const props = defineProps<PhxsgLightboxBackgroundVideoItemProps>();

defineEmits<{
  mounted: [payload: BackgroundVideoMountPayload];
}>();

watch(
  () => props.components.backgroundVideoComponent,
  (component) => {
    if (!component) {
      console.warn('[phxsg-lightbox] Missing backgroundVideoComponent for background-video lightbox item.');
    }
  },
  { immediate: true },
);
</script>

<template>
  <component
    :is="components.backgroundVideoComponent"
    v-if="components.backgroundVideoComponent"
    :sources="item.data.sources"
    :poster="item.data.poster"
    :autoplay="true"
    :loop="true"
    :initialize="true"
    :play-label="i18n?.backgroundVideo?.play ?? 'Play'"
    :pause-label="i18n?.backgroundVideo?.pause ?? 'Pause'"
    class="phxsg-lightbox__background-video"
    @background-video:mounted="$emit('mounted', $event)"
  />
</template>
